import { render } from "./columnChartItem.vue?vue&type=template&id=7522bbab"
import script from "./columnChartItem.vue?vue&type=script&lang=js"
export * from "./columnChartItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__